import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { CmsComponentData, LAUNCH_CALLER, LaunchDialogService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { CmsBlpFooterContentComponent } from '../../../../core/model';
import { LegalModalData } from '../../../../shared/components/legal-modal/legal-modal.component';
import { NavigationService } from '../../../navigation/cms-libs/navigation';
import { NavigationNode } from '../../../navigation/cms-libs/navigation/navigation-node.model';

@Component({
  templateUrl: './footer-content.component.html',
  styleUrls: ['./footer-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FooterContentComponent {
  private readonly PROTOCOL_REGEX: RegExp = /^https?:\/\//i;

  node$: Observable<NavigationNode> = this.navigationService.createNavigation(this.componentData.data$);
  modal: any;

  constructor(
    private componentData: CmsComponentData<CmsBlpFooterContentComponent>,
    private navigationService: NavigationService,
    private launchDialogService: LaunchDialogService,
    private cmsService: CmsService
  ) {}

  isExternalUrl(url: string): boolean {
    return typeof url === 'string' && this.PROTOCOL_REGEX.test(url);
  }

  openModal(link: NavigationNode): void {
    const modalData: LegalModalData = {
      component$: this.cmsService.getComponentData((link.url as string).replace(/^\//, '').concat('_paragraph')),
    };

    this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.LEGAL, undefined, modalData);
  }
}
